module.exports = __webpack_public_path__ + "img/Unicom-2.2387e2f8.svg";